// ------------------------ utility - also used outside this file ------------------------ //

setCookie = function (name, value, expireSeconds = 86400) {
    let expires = ''

    if (expireSeconds) {
        let date = new Date()

        date.setTime(date.getTime() + expireSeconds * 1000)

        expires = '; expires=' + date.toUTCString()
    }

    document.cookie = name + '=' + (value || '') + expires + ';domain=.' + document.location.host + ';path=/'
}

readCookie = function(name) {
    return document.cookie
        .split('; ')
        .find((row) => row.startsWith(name + '='))
        ?.split('=')[1]
}

matchHeight = function (el) { //this function only used in homepage.blade.php and lp_homepage.blade.php
    //Apply this class name match-height to match the height horizontally then call this function
    let getDivs = document.getElementsByClassName(el);

    const arrayLength = getDivs.length;
    let heights = []

    for (let i = 0; i < arrayLength; i++) {
        heights.push(getDivs[i].offsetHeight)
    }

    for (let i = 0; i < getDivs.length; i++) {
        getDivs[i].style.height = Math.max(...heights) + 'px'
    }
}

smoothScrollingTo = function (targetSelector) {
    if (targetSelector && targetSelector !== '#') {
        let targetElement = document.querySelector(targetSelector)

        if (typeof (targetElement) != 'undefined' && targetElement !== null) {
            targetElement.scrollIntoView({ //position is affected by css definition `scroll-margin-top`
                behavior: 'smooth'
            })
        }
    }
}

loadScript = function (url, callback) {
    const scriptJS = document.createElement('script')
    scriptJS.type = 'text/javascript';
    scriptJS.src = url;
    scriptJS.addEventListener('load', callback)
    document.head.appendChild(scriptJS)
}

// ------------------------ Form JS - Toggle ------------------------ //

toggleLoading = function (inputElement, is_loading) {
    switch (inputElement.tagName) {
        case 'INPUT':
            toggleInputLoading(inputElement, is_loading)
            break
        case 'SELECT':
            toggleSelectLoading(inputElement, is_loading)
            break
    }
}

toggleInputLoading = function (inputElement, is_loading) {
    inputElement.classList.remove('is-invalid')
    inputElement.classList.remove('is-valid')

    // let elementValid = document.querySelector('#input-valid-' + inputElement.id)
    //
    // if (typeof (elementValid) != 'undefined' && elementValid !== null) {
    //     elementValid.remove()
    // }

    let elementLoading = document.querySelector('#input-loading-' + inputElement.id)

    if (is_loading === true) {
        if (typeof (elementLoading) === 'undefined' || elementLoading === null) {
            let div = document.createElement('div')
            div.className = 'input-container'
            div.id = 'input-loading-' + inputElement.id

            let i = document.createElement('i')
            i.className = 'input-loading'

            div.appendChild(i)

            inputElement.parentNode.appendChild(div)
        }
    } else {
        if (typeof (elementLoading) != 'undefined' && elementLoading !== null) {
            elementLoading.remove()
        }
    }
}

toggleSelectLoading = function (inputElement, is_loading) {
    if (is_loading === true) {
        inputElement.classList.add('is-loading')
    } else {
        inputElement.classList.remove('is-loading')
    }
}

toggleValid = function (inputElement, is_valid) {
    switch (inputElement.tagName) {
        case 'INPUT':
            toggleInputValid(inputElement, is_valid)
            break
        case 'SELECT':
            toggleSelectValid(inputElement, is_valid)
            break
    }
}

toggleSelectValid = function (inputElement, is_valid) {
    if (is_valid === true) {
        inputElement.classList.remove('is-invalid')
        inputElement.classList.add('is-valid')
    } else {
        inputElement.classList.add('is-invalid')
        inputElement.classList.remove('is-valid')
    }
}

toggleInputValid = function (inputElement, is_valid) {
    // let elementValid = document.querySelector('#input-valid-' + inputElement.id)

    if (is_valid === true) {
        inputElement.classList.remove('is-invalid')
        inputElement.classList.add('is-valid')

        // if (typeof (elementValid) == 'undefined' || elementValid === null) {
        //     let div = document.createElement('div')
        //     div.className = 'input-container'
        //     div.id = 'input-valid-' + inputElement.id
        //
        //     let i = document.createElement('i')
        //     i.className = 'input-valid'
        //
        //     div.appendChild(i)
        //
        //     inputElement.parentNode.appendChild(div)
        // }
    } else {
        inputElement.classList.add('is-invalid')
        inputElement.classList.remove('is-valid')

        // if (typeof (elementValid) != 'undefined' && elementValid !== null) {
        //     elementValid.remove()
        // }
    }
}

toggleInputError = function (inputElement, stepElement, is_valid, with_error) {
    const id = inputElement.id

    toggleValid(inputElement, is_valid)

    if (is_valid === false) {
        inputElement.focus()

        if (with_error === true) {
            stepElement.querySelector('#' + id + '_error').style.display = 'block'
        }
    } else {
        stepElement.querySelector('#' + id + '_error').style.display = 'none'
    }
}

// ------------------------ results related ------------------------ //

setLoadingMobile = function () { //this function can be moved to default.js, calculator.js, lp.js
    let loadSteps
    let currentStep = 1
    let is_mobile = window.matchMedia('(max-width: 767px)').matches

    let timeout = 1500

    function changeStep() {
        let nextStep = currentStep + 1

        document.querySelector('#loading-' + currentStep).classList.add('animate__animated', 'animate__zoomOut')
        document.querySelector('#loading-' + nextStep).style.display = 'block'
        document.querySelector('#loading-' + nextStep).classList.add('animate__animated', 'animate__zoomIn')
        currentStep = nextStep

        if (currentStep === 3) {
            clearInterval(loadSteps)
        }
    }

    if (is_mobile === true) {
        loadSteps = setInterval(changeStep, timeout)
    }
}

// ------------------------ everflow related ------------------------ //

const EF = require('@everflow/everflow-sdk');

EF.configure({
    // You only need to set the tracking domain you want to use
    tracking_domain: 'https://www.zrwike2er.com',
})

getEverflowParameter = function (key) {
    //get value by URL parameter and if it doesn't exist look for cookie value
    let value = EF.urlParameter(key) || readCookie(key)

    //if value is not present use default values
    if (!value) {
        switch (key) {
            case 'oid':
                value = '7506'
                break
            case 'affid':
                value = '162979'
                break
            case 'source_id':
                value = 'organic'
                break
        }
    }

    //for selected keys add cookie (note: used in the backend)
    if (value && ['oid', 'affid', 'sub3', 'sub4', 'sub5'].includes(key) === true) {
        setCookie(key, value, 86400)
    }

    return value
}

setTransactionId = function (transaction_id) {
    console.log(transaction_id)

    ringbaPushTransactionId(transaction_id)

    let inputTransactionID = document.querySelector('#transaction_id')

    if (typeof (inputTransactionID) != 'undefined' && inputTransactionID !== null) {
        inputTransactionID.value = transaction_id
    }
}

ringbaPushTransactionId = function (transaction_id) {
    window._rgba_tags = (window._rgba_tags || [])
    window._rgba_tags.push({transaction_id: transaction_id})
}

setupEverflow = function() {
    const oid = getEverflowParameter('oid')
    let transaction_id = EF.getTransactionId(oid)

    if (transaction_id) {
        setTransactionId(transaction_id)
    } else {
        EF.click({
            offer_id: oid,
            affiliate_id: getEverflowParameter('affid'),
            sub1: getEverflowParameter('sub1'),
            sub2: getEverflowParameter('sub2'),
            sub3: getEverflowParameter('sub3'),
            sub4: getEverflowParameter('sub4'),
            sub5: getEverflowParameter('sub5'),
            uid: getEverflowParameter('uid'),
            source_id: getEverflowParameter('source_id'),
            transaction_id: getEverflowParameter('_ef_transaction_id'),
            parameters: {
                ttclid: getEverflowParameter('ttclid'),
                gclid: getEverflowParameter('gclid'),
            },
        }).then(function (transaction_id) {
            setTransactionId(transaction_id)
        })
    }
}
